// extracted by mini-css-extract-plugin
module.exports = {"rating":"styles_rating__0Q7Lu","stroke":"styles_stroke__76w2w","fill":"styles_fill__7ih_C","stars":"styles_stars__3AO1n"};